import { isJQuery } from '@Common/Helpers/CommonUtils';

export interface IDestroyable {
    destroy(): void;
}

export function isDestroyable(obj: Partial<IDestroyable>): obj is IDestroyable {
    return obj && _.isFunction(obj.destroy);
}

function isElement(obj: any): obj is Element {
    return obj instanceof Element;
}

const makeDestroy = <T>(check: (a: Partial<T>) => a is T, exec: ICallback<T>): _.CondPair<T, true> => [check, _.flow(exec, _.stubTrue)];

type AllDestroyable = IDestroyable | Element | JQuery;

export const safeDestroy: (obj: unknown) => boolean = _.cond<Partial<AllDestroyable>, boolean>([
    makeDestroy(isDestroyable, d => d.destroy()),
    makeDestroy(isJQuery, d => d.remove()),
    makeDestroy(isElement, d => d.remove()),
    [_.stubTrue, _.stubFalse]
]);

export function safeDestroys(...values: unknown[]): boolean {
    return values.reduce<boolean>((acc, cur) => safeDestroy(cur) && acc, true);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function destroyEvents(own: Record<string, any>): void {
    Object.keys(own)
        .filter(key => key.startsWith('_on') && Function.isFunction(own[key]))
        .forEach(callbackName => (own[callbackName] = _.noop));
}
